import {useContext} from 'react'

import {AddressContext} from '../contexts/AddressContext'

export const useAddressContext = () => {
  const addressContext = useContext(AddressContext)

  if (!addressContext) {
    throw new Error('useAddressContext must be used within an AddressProvider')
  }

  return addressContext
}
